// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DYlKCgBmPkhG9M {
  width: 254px;
  margin-bottom: 24px;
  padding-right: 16px;
}
.DYlKCgBmPkhG9M:nth-of-type(3n) {
  padding-right: 0;
}
.Md64HqP2KVfsZH {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
._7ho5VPYi4fAn4H {
  width: 32px;
  height: 32px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 24px;
}
._7ho5VPYi4fAn4H::before {
  vertical-align: middle;
}
.mPb9B0SWZ3nEA4 {
  display: flex;
  align-items: center;
}
.u5VAJhsTUOKubh {
  margin-top: 24px;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: 0;
  padding-left: 12px;
}
.gOPTbFIxyg80uO {
  max-height: 75px;
  margin-top: 8px;
  overflow: hidden;
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DYlKCgBmPkhG9M`,
	"icon": `Md64HqP2KVfsZH`,
	"defaultIcon": `_7ho5VPYi4fAn4H`,
	"titleArea": `mPb9B0SWZ3nEA4`,
	"name": `u5VAJhsTUOKubh`,
	"description": `gOPTbFIxyg80uO`
};
export default ___CSS_LOADER_EXPORT___;
